import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GLOBAL } from 'src/app/services/global';
//import { Seguimiento_certificadoComponent } from '../../seguimiento_certificado/seguimiento_certificado.component';

import { SeguimientoCertificadosComponent } from 'src/app/components/seguimiento-certificados/seguimiento-certificados.component';


@Component({
    selector: "page-auxUrlcert",
    templateUrl: "auxUrlcert.component.html",
    styleUrls: ["./auxUrlcert.component.css"]
})

export class AuxUrlCertComponent{
  public nombreMuni = GLOBAL.nombreMuni;
  public filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  
  public seguimientoCertificados = GLOBAL.seguimientoCertificados;
  constructor(private dialog: MatDialog, private _router:Router ){

  }

  sign(tipo) {
    if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
      this.dialog.closeAll();
      if (tipo == 'seg-certificados') {
        this._router.navigate([`/seguimiento_certificados`]);
        //this.dialog.open(SeguimientoCertificadosComponent);
      }
    } else {
      console.log("entre en el else")
      if (tipo == 'seg-certificados') {
        this._router.navigate([`/seguimiento_certificados`]);
        //this.dialog.open(SeguimientoCertificadosComponent);
      }
    }
    this.dialog.closeAll()
  }

  /* seguimiento (){
    this.dialog.open(Seguimiento_certificadoComponent);
  } */
}
